import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApButtonLinkComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApNotificationComponent } from '@ap/notification';
import { ApHeaderComponent } from '@ap/header';
import { ApPanelComponent } from '@ap/panel';
import { ApCookieConsentService } from '@ap/cookie-consent';
import { ApCookieService } from '@ap/persistence';

import { HuismapComponent } from './huismap.component';

/**
 * @name HuismapModule
 *
 * @ngdoc module
 */
@NgModule({
    imports: [
        BrowserAnimationsModule,
        ApContentModule,
        ApHeaderComponent,
        ApPanelComponent,
        ApNotificationComponent,
        ApButtonLinkComponent
    ],
    declarations: [HuismapComponent],
    exports: [HuismapComponent],
    providers: [{ provide: LOCALE_ID, useValue: 'nl' }, ApCookieConsentService, ApCookieService],
    bootstrap: [HuismapComponent]
})
export class HuismapModule {}
